export default "__VITE_ASSET__CiPbB8uu__"